<script lang="ts">
    import { getCachedEntries } from "../../../api"
    import NewsTeaserArticle from "./NewsTeaser_Article.svelte"

    export let block: ContentBlockEntry

    let loading = true
    let news: ContentEntry[]

    getCachedEntries("content", { type: "news", active: true }, "-news.date", 3, 0, "newsTeaser").then((data) => {
        loading = true
        news = data
        loading = false
    })
</script>

<div class="container" data-block-cfg="{block.newsTeaser}">
    {#if loading}
        <div class="loader"></div>
    {:else if news?.length}
        <div class="grid">
            {#each news as newsEntry}
                <NewsTeaserArticle {newsEntry} />
            {/each}
        </div>
    {/if}
</div>
